var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 22,
    height: 27,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285",
    transform: "translate(0.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284",
    transform: "translate(-0.296)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27603",
    "data-name": "Path 27603",
    d: "M6.693,10.708H8.031a1.339,1.339,0,0,0,0-2.677H6.693a1.339,1.339,0,1,0,0,2.677m0,2.677a1.339,1.339,0,1,0,0,2.677h8.031a1.339,1.339,0,1,0,0-2.677Zm14.724-4.1a1.514,1.514,0,0,0-.084-.355V8.806a1.189,1.189,0,0,0-.252-.369L13.05.405a1.216,1.216,0,0,0-.375-.259.336.336,0,0,0-.12,0A1.263,1.263,0,0,0,12.116,0h-8.1A4.017,4.017,0,0,0,0,4.016V22.755A4.017,4.017,0,0,0,4.016,26.77H17.4a4.017,4.017,0,0,0,4.016-4.016V9.286M13.385,4.567l3.464,3.464H14.724a1.339,1.339,0,0,1-1.339-1.339Zm5.354,18.188A1.339,1.339,0,0,1,17.4,24.093H4.016a1.339,1.339,0,0,1-1.339-1.339V4.016A1.339,1.339,0,0,1,4.016,2.677h6.693V6.693a4.017,4.017,0,0,0,4.016,4.016h4.016Zm-4.016-4.016H6.693a1.339,1.339,0,0,0,0,2.677h8.031a1.339,1.339,0,1,0,0-2.677",
    transform: "translate(0.247)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/service_icon.19081ddaf83b9e291a15fd9053f04d91.svg";
export { ForwardRef as ReactComponent };